import axios from "axios";

export const getFormattedError = (error: Error | null) => {
  if (error && axios.isAxiosError(error) && error.response) {
    return error.response.data;
  }

  return null;
};
